import React from 'react'

export default function RightSideArrowIco() {
  return (
    <svg
      width="4"
      height="8"
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.167939 7.32735C0.0559794 7.21226 0 7.06577 0 6.88789C0 6.71001 0.0559794 6.56353 0.167939 6.44843L2.54962 4L0.167939 1.55157C0.0559794 1.43647 0 1.28998 0 1.11211C0 0.93423 0.0559794 0.787743 0.167939 0.672645C0.279898 0.557548 0.422391 0.5 0.595419 0.5C0.768447 0.5 0.910942 0.557548 1.0229 0.672645L3.83206 3.56054C3.89313 3.62332 3.93649 3.69133 3.96214 3.76457C3.98738 3.83782 4 3.91629 4 4C4 4.08371 3.98738 4.16218 3.96214 4.23543C3.93649 4.30867 3.89313 4.37668 3.83206 4.43946L1.0229 7.32735C0.910942 7.44245 0.768447 7.5 0.595419 7.5C0.422391 7.5 0.279898 7.44245 0.167939 7.32735Z"
        fill="black"
      />
    </svg>
  )
}
